import React from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import TooltipButton from './TooltipButton.tsx';

function AccessIndicator({ score, max, needLabel = true, showNumeric = false }) {
    const ratio = max > 0 ? score / max : 0;
    const level = ratio > 0.7 ? 3 : ratio > 0.4 ? 2 : ratio > 0.1 ? 1 : 0;
    const label = ratio > 0.7 ? "High" : ratio > 0.4 ? "Medium" : ratio > 0.1 ? "Low" : "None";
    const color = ratio > 0.7 ? "#28a745" : ratio > 0.4 ? "#ffc107" : ratio > 0.1 ? "#6c757d" : "#adb5bd";

    const tooltipText = `${label} Access (${score} of ${max})`;

    return (
        <div className="d-flex align-items-center gap-2">
            <TooltipButton title="Access is determined by the combined weight of assigned roles. More weight = broader access.">
                <div className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1 cursor-pointer">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <span
                                key={i}
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: i < level ? color : '#dee2e6',
                                    transition: 'background-color 0.3s ease'
                                }}
                            />
                        ))}
                    </div>
                    {needLabel && (
                        <span className="d-flex align-items-center" style={{ fontSize: '0.9rem', color }}>
                            <FaShieldAlt className="me-1" /> {label} Access
                        </span>
                    )}
                </div>
            </TooltipButton>
            {showNumeric && (
                <span className="text-muted-theme small ms-2">
                    ({score}/{max})
                </span>
            )}
        </div>
    );
}

export default AccessIndicator;
